import React from 'react';
import { Text, Props, FontScale, FontWeight } from '@prisjakt/ui/text';

export const PriceText: React.FC<Props> = props => {
  const { scale, weight, ...otherProps } = props;
  const newScale = scale ?? FontScale.M;
  const newWeight = weight ?? FontWeight.HEAVIEST;
  return <Text {...otherProps} scale={newScale} weight={newWeight} />;
};
